import React from 'react'
import BasketStatisticsHeader from './BasketStatisticsTable/BasketStatisticsHeader'
import BasketStatisticsRow from './BasketStatisticsTable/BasketStatisticsRow'

function BasketStatisticsTable(props) {
    const { listBasket, loading, tableType, tableAdd, tableDelete } = props
    return (
        <table className='table table-borderless table-striped BasketStatisticsTable'>
            <BasketStatisticsHeader
                tableType={tableType}
            />
            <tbody className="BasketStatisticsRow">
                {
                    !!listBasket && listBasket.length > 0 && listBasket.map((item, i) => {
                        return <BasketStatisticsRow
                            key={i}
                            index={i}
                            item={item}
                            tableType={tableType}
                        />
                    })
                }
                {
                    !loading && (!listBasket || listBasket.length === 0) &&
                    <tr>
                        <td colSpan={tableType === 'tableAdd' ? 6 : (tableType === 'tableDelete' ? 5 : '')}>
                            No result
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    )
}

export default BasketStatisticsTable